import React, { useEffect } from "react";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../store/helpers/mapDispatch";
import { mapStateToProps } from "store/helpers/mapState";
import MainPage from "./MainPage";
import { ToastContainer } from "react-toastify";

function Admin(props) {
  const {
    GetLoggedUser,
    GetUserPermissions,
    GetAllMenus,
    userPermissions,
    loggedUser,
    selectedMenu,
    SetSelectedMenu,
    GetMyStructure,
    systemSettings,
    GetWholeStructure
  } = props;
  const resourceId = loggedUser?.Resource?.id;


  useEffect(() => {
    GetLoggedUser();
    GetAllMenus();
    GetMyStructure();
    GetWholeStructure();
  }, [GetLoggedUser, GetAllMenus, GetMyStructure, GetWholeStructure]);

  useEffect(() => {
    if (resourceId) GetUserPermissions(resourceId);
  }, [GetUserPermissions, resourceId]);

  return (
    <>
      <Sidebar
        userPermissions={userPermissions?.filter(
          (item) => item?.type === "menu" && item.read
        )}
        loggedUser={loggedUser}
        selectedMenu={selectedMenu}
        SetSelectedMenu={SetSelectedMenu}
        systemSettings={systemSettings}
      />
      <div className="relative min-[1324px]:ml-[264px]">
        <AdminNavbar systemSettings={systemSettings} />
        <ToastContainer />
        <HeaderStats systemSettings={systemSettings} />
        <div
          className="px-4 md:px-10 mx-auto w-full relative"
          style={{ marginTop: "-6rem", zIndex: 9 }}
        >
          <MainPage />
          <FooterAdmin systemSettings={systemSettings} />
        </div>
      </div>
      {/* Session Warning Dialog */}
      {/* <SessionWarningDialog systemSettings={systemSettings} /> */}
      {/* Session Debug Info (only in development) */}
      {/* <SessionDebugInfo systemSettings={systemSettings} /> */}
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
